exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cs-pdfButton__section {\n  padding: 1em;\n  align-content: center;\n  text-align: center;\n}\n.cs-pdfButton {\n  width: 200px;\n}\n.cs-pdf {\n  margin: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/SurveySummary/PdfButton/PdfButton.less
// module id = 975
// module chunks = 0